export default __webpack_public_path__ + "static/media/persona-image.ddc90192.svg";